import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import PageHome from './pages/home';
import PageCapture from './pages/capture';
import PageGenerate from './pages/generate';
import PageResult from './pages/result';
import PageBiodata from './pages/biodata';
import PageQuestion from './pages/question';

function App() {

  return (
    <div className="flex min-h-screen justify-center bg-black">
      {/* Portrait Kiosk Layout */}
      <div className="relative h-screen w-full max-w-[720px] overflow-hidden bg-white">
      <Routes>
          <Route path="/" element={<PageHome />} />
          {/* <Route path="/biodata" element={<PageBiodata />} /> */}
          <Route path="/question" element={<PageQuestion />} />
          <Route path="/capture" element={<PageCapture />} />
          <Route path="/generate" element={<PageGenerate />} />
          <Route path="/result" element={<PageResult />} />
        </Routes>
      </div>
    </div>

  );
}

export default App;
